/**
 * Created by luka on 23.02.2018.
 */

import {
    FEEDBACK_FETCH_DATA_SUCCESS,
    FEEDBACK_LOADING, LOADING_FEEDBACK_FAILED
} from "../actions/types";
export function loadingFeedbackFailed(state = false, action) {
    switch (action.type) {
        case LOADING_FEEDBACK_FAILED:
            return action.error;
        default:
            return state;
    }
}
export function feedbackLoading(state = false, action) {
    switch (action.type) {
        case FEEDBACK_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}

export function feedbackSet(state = {}, action) {
    switch (action.type) {
        case FEEDBACK_FETCH_DATA_SUCCESS:
            return action.login;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/rating/FeedbackReducer.js